import * as React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { GatsbyImage } from "gatsby-plugin-image"
import { useSiteContext } from "../hooks/use-site-context"
import { useOutsideClick } from "../hooks/use-outside-click"
import { MdClose } from "react-icons/md"

const ExitIntentModal = () => {
  const [modalOpen, setModalOpen] = React.useState(true)
  const [isCheckoutLoading, setIsCheckoutLoading] = React.useState(false)

  const { setExitIntent, selectedSign, firstName } = useSiteContext()

  const handleOutsideClick = () => {
    setModalOpen(false)
    setExitIntent(false)
  }

  const ref = useOutsideClick(handleOutsideClick)

  return (
    <div className={`exit-intent-modal-container`}>
      <div
        ref={ref}
        className={`fixed pb-6 md:pb-12 w-full max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-4xl top-6 -translate-y-0 md:top-1/3 left-1/2 -translate-x-1/2 md:-translate-y-1/3 bg-brand-dark`}
      >
        <div className="relative w-full h-full">
          <MdClose
            onClick={() => {
              setModalOpen(false)
              setExitIntent(false)
            }}
            className="absolute text-white cursor-pointer md:text-lg lg:text-xl top-2 right-2"
          />
          <div className="flex justify-center pt-12">
            <StaticImage
              quality={95}
              loading={"eager"}
              src="../images/stop-sign.png"
              placeholder="blurred"
              alt={"stop sign"}
              className={`w-32 md:w-48`}
            />
          </div>
          <div className="px-4 mt-6 text-xl font-bold text-center text-white md:mt-8 md:text-3xl">
            <span className="">
              Don't leave yet, {firstName !== "" ? firstName : selectedSign}!
            </span>
            <br className="" />
            <br className="hidden md:block" />
            <div className="mt-4 text-sm text-white md:text-xl md:mt-0">
              The stars hold a beautiful secret about your future.
              <br />I beg you: stay with me. The truth will soon be revealed.
            </div>
          </div>
          <button
            className={`bg-brand-darkPink hover:bg-brand-pink whitespace-nowrap transition mx-auto flex justify-center ease-in-out hover:scale-110 duration-200 px-12 py-2 mt-8 md:mt-12 text-base md:text-lg text-white font-bold rounded-full`}
            type="button"
            onClick={() => {
              setModalOpen(false)
              setExitIntent(false)
            }}
          >
            CONTINUE MY READING
          </button>
          {/* <button
            className={`bg-red-900 whitespace-nowrap mx-auto flex justify-center px-12 py-2 mt-4 md:mt-6 text-base md:text-lg text-white font-bold rounded-full`}
            type="button"
            onClick={() => {
              setModalOpen(false)
              setExitIntent(false)
            }}
          >
            NO THANK YOU
          </button> */}
        </div>
      </div>
    </div>
  )
}

export default ExitIntentModal
